import React from "react";
import fr from "../assets/fr.png";
import sal from "../assets/sal.png";
import mar from "../assets/mar.png";
import dr from "../assets/dr.png";
import tns from "../assets/tns.png";
import ai from "../assets/ai.png";
import Footer from "./Footer";

const ProjectCard = ({ image, title, description, git, technologies }) => {
  let projectImage = null;

  // Determine which image to use based on project title
  if (title === "Insurance Fraud Detection") {
    projectImage = fr;
  } else if (title === "Sales Insights Dashboard using Power BI and SQL") {
    projectImage = sal;
  } else if (title === "Big Mart Sales Prediction using Machine Learning") {
    projectImage = mar;
  } else if (title === "Drowsiness Detection System") {
    projectImage = dr;
  } else if (title === "Style Transfer using TensorFlow") {
    projectImage = tns;
  } else if (title === "Reinforcement Learning AI Agent") {
    projectImage = ai;
  }

  return (
    <div className="max-w-sm sm:max-w-sm md:max-w-sm bg-gray-900 border border-neutral-100 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
      <a href="#">
        <img
          className="w-full rounded-t-lg h-auto object-cover"
          src={projectImage} // Use the determined project image
          alt=""
        />
      </a>
      <div className="p-4 sm:p-6">
        <a href="#">
          <h5 className="text-2xl sm:text-xl md:text-2xl lg:text-3xl font-bold tracking-tight text-white bg-clip-text text-transparent bg-gradient-to-r from-yellow-200 to-pink-500">
            {title}
          </h5>
        </a>
        <p className="font-normal text-sm sm:text-base md:text-lg text-gray-300 dark:text-gray-400">
          {description}
        </p>
      </div>
      <div className="m-2 sm:m-4 lg:m-6 flex justify-between">
        <div className="flex flex-wrap gap-2 pl-2">
          {technologies.map((tag, index) => (
            <p key={`${index}-${tag}`} className="text-[14px] text-blue-500">
              #{tag}
            </p>
          ))}
        </div>
        <a
          href={git}
          className="text-red-300 border border-gray-200 rounded-lg shadow p-1 sm:p-2 lg:p-3 hover:text-green-500 duration-300"
        >
          GitHub
        </a>
      </div>
    </div>
  );
};


const Projects = () => {
  return (
    <div className="bg-black">
      <div className="flex flex-wrap gap-7 justify-center items-center m-12 p-12">
        {projects.map((item, index) => (
          <ProjectCard
            key={index}
            title={item.title}
            description={item.description}
            git={item.git}
            technologies={item.technologies}
          />
        ))}
      </div>
      <Footer />
    </div>
  );
};


export const projects = [
    {
        title: 'Insurance Fraud Detection',
        description: 'Built a machine learning model with 98% accuracy to detect fraudulent insurance claims. Employed Random Forest for predictive analysis to determine the legitimacy of insurance claims.',
        image: fr, // Replace with actual image URL
        git: 'https://github.com/SheikhJones/insurance-fraud-detection',
        technologies: ['Machine Learning', 'Random Forest']
    },
    {
        title: 'Sales Insights Dashboard using Power BI and SQL',
        description: 'Created actionable insights for retail sales performance and customer Utilized Power BI and SQL to support data-driven decision-making Empowered the retail company with a comprehensive sales insights dashboard.',
        image: sal, // Replace with actual image URL
        git: 'https://github.com/SheikhJones/power-bi',
        technologies: ['Power BI', 'SQL', 'Data Analysis']
    },
    {
        title: 'Big Mart Sales Prediction using Machine Learning',
        description: 'Enhanced data analysis, ML, and problem-solving through Big Mart Sales Prediction project Developed skills in data preprocessing, feature engineering, and ML model creation Gained insights into retail dynamics and complex sales patterns.',
        image: mar, // Replace with actual image URL
        git: 'https://github.com/SheikhJones/Big-Mart-Sales-Prediction-using-Machine-Learning',
        technologies: ['Machine Learning', 'Data Preprocessing', 'Feature Engineering']
    },
    {
        title: 'Reinforcement Learning AI Agent',
        description: 'Developed an AI agent using Q-learning to navigate and optimize strategies in various Snake game levels, focusing on maximizing scores and adapting to dynamic environments. Implemented a deep Q-network (DQN) with PyTorch, leveraging experience replay and target network updates, improving game performance by 15%.',
        image: ai, // Replace with actual image URL
        git: 'https://github.com/SheikhJones/Reinforcement-Learning-AI-Agent',
        technologies: ['Python', 'PyTorch', 'Q-learning', 'DQN']
    },
    {
        title: 'Style Transfer using TensorFlow',
        description: 'Developed a VGG19-based style transfer model, significantly reducing the loss function by 85% over 4000 iterations. Merged content from base images with reference image styles, producing high-quality results with enhanced image quality and coherence.',
        image: tns, // Replace with actual image URL
        git: 'https://github.com/SheikhJones/Style-Transfer-using-TensorFlow',
        technologies: ['Python', 'TensorFlow', 'VGG19']
    },
    {
        title: 'Drowsiness Detection System',
        description: 'Developed a comprehensive system integrating computer vision and real-time monitoring to enhance road safety by detecting driver drowsiness. Utilized the Haar Cascade algorithm to accurately detect signs of drowsiness, creating an intuitive UI to alert drivers and authorities.',
        image: dr, // Replace with actual image URL
        git: 'https://github.com/SheikhJones/Drowsiness-Detection-System',
        technologies: ['Python', 'OpenCV', 'Computer Vision', 'Haar Cascade']
    }
];


export default Projects;
